import { useState } from 'react';
import { useEventGroup, useEventGroupsLoadDone } from 'modules/common/hooks';
import { first, isEmpty, isFunction } from 'mojito/utils';
import MojitoPresentation from 'mojito/presentation';

const { FlexPane, MenuRow, MenuRowSkeleton, LoaderSuspense } = MojitoPresentation.Components;

export default function LeaguesFilterSection(props) {
    const { mojitoTools, groupId, children } = props;
    const {
        config,
        appContext: { analyticsEmitter },
    } = mojitoTools;
    const eventGroups = useEventGroup(groupId);
    const eventGroupLoadDone = useEventGroupsLoadDone([groupId]);
    const noContent = eventGroupLoadDone && isEmpty(eventGroups);
    const [manuallySelectedLeagueId, setManuallySelectedLeagueId] = useState();
    const selectedLeagueId = manuallySelectedLeagueId || first(eventGroups)?.id;

    const getMenuItems = leagues => {
        return leagues.map(league => {
            const { id, countryCode, typeName } = league;
            return {
                id,
                data: typeName,
                icon: config.countryIcons[countryCode],
            };
        });
    };

    const onLeagueClicked = leagueId => {
        const league = eventGroups.find(group => group.id === leagueId);
        analyticsEmitter.emitAnalytics('sportClassTypeClicked', {
            pageType: 'bet builders',
            typeName: league.canonicalTypeName,
        });
        setManuallySelectedLeagueId(leagueId);
    };

    const skeleton = <MenuRowSkeleton config={config.menuRowSkeleton} />;

    if (noContent) {
        return null;
    }

    return (
        <FlexPane config={config.container} class={'ta-LeaguesFilterSection'}>
            <LoaderSuspense
                config={config.skeletonLoader}
                isContentPending={!eventGroupLoadDone}
                loader={skeleton}
            >
                {eventGroups?.length > 1 && (
                    <MenuRow
                        config={config.navigationMenu}
                        menuItems={getMenuItems(eventGroups)}
                        selectedItemId={selectedLeagueId}
                        cbItemClicked={onLeagueClicked}
                    />
                )}
            </LoaderSuspense>
            {isFunction(children) ? children(selectedLeagueId) : children}
        </FlexPane>
    );
}
